// Previous Qty column of the Supplier PO Amend verification grid (Purchase/GetSupplierPOAmendbyPO lstItems).
// spGetSupplierPOAmend returns the PO qty before this amendment as CurrentQty (0 for 'New' items).
// The entity's `quantity` field is never filled by that SP and always serialises as 0, so it must not be used.
export const previousPOQty = (item) => item?.CurrentQty ?? '-';
